import { Badge, Group, Paper, Text } from "@mantine/core";
import { useCallback, useMemo } from "react";
import { Case } from "../../services/cases.service";
import { formatDateOnlyForDisplay, parseDateOnly } from "../../utils/dateOnly";

interface RelatedCaseCardProps {
  caseData: Case;
  onNavigate: (caseId: string) => void;
}

export function RelatedCaseCard({
  caseData,
  onNavigate,
}: RelatedCaseCardProps) {
  const handleClick = useCallback(() => {
    onNavigate(caseData.id);
  }, [caseData.id, onNavigate]);
  const receivedDate = useMemo(() => {
    const dateReceived = parseDateOnly(caseData.dateReceived);
    return dateReceived ? formatDateOnlyForDisplay(dateReceived) : undefined;
  }, [caseData.dateReceived]);

  return (
    <Paper
      p="xs"
      withBorder
      styles={{ root: { cursor: "pointer" } }}
      onClick={handleClick}
    >
      <Group justify="space-between" wrap="nowrap">
        <Text size="xs" fw={600} truncate>
          {caseData.caseNumber}
        </Text>
        <Badge
          size="xs"
          variant="light"
          color={
            caseData.currentStatus?.name === "Signed Off"
              ? "green"
              : caseData.currentStatus?.name === "Pathologist Review"
              ? "blue"
              : "gray"
          }
        >
          {caseData.currentStatus?.name ?? "Unknown"}
        </Badge>
      </Group>
      <Group gap={4} mt={2}>
        {caseData.procedure?.name && (
          <Text size="xs" c="dimmed">
            {caseData.procedure.name}
          </Text>
        )}
        {caseData.procedure?.name && receivedDate && (
          <Text size="xs" c="dimmed">
            &middot;
          </Text>
        )}
        {receivedDate && (
          <Text size="xs" c="dimmed">
            {receivedDate}
          </Text>
        )}
      </Group>
    </Paper>
  );
}
